import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../Assets/newlogo.png'

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LEFT SECTION */}
        <div className="footer-col footer-left">
          <div className="footer-logo">
            <img src={logo} alt="Logo" />
          </div>

          <div className="footer-contact">
            <div className="contact-item">
              <span className="icon">
                <i className="bi bi-telephone-fill"></i>
              </span>
              <div>
                <p>Feel free to call me</p>
                <h4>7703895964</h4>
              </div>
            </div>

            <div className="contact-item">
              <span className="icon">
                <i className="bi bi-envelope-fill"></i>
              </span>
              <div>
                <p>Email me at</p>
                <h4>drmonicaivf@gmail.com</h4>
              </div>
            </div>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/" className='none'>Home</Link></li>
            <li><Link to="/about" className='none'>About Dr. Monika Gupta</Link></li>
            <li><Link to="/services" className='none'>Our Treatments</Link></li>
            <li><Link to="/blog" className='none'>Blog</Link></li>
            <li><Link to="/contact" className='none'>Contact Us</Link></li>
          </ul>
        </div>

        {/* PATIENT RESOURCES */}
        <div className="footer-col">
          <h3>Patient Resources</h3>
          <ul>
            <li><Link to="/services" className='none'>IVF Treatments</Link></li>
            <li><Link to="/blog" className='none'>Fertility Articles</Link></li>
            <li><Link to="/contact" className='none'>Book Appointment</Link></li>
          </ul>
        </div>

        {/* CONSULTATION TIMINGS */}
<div className="footer-col">
  <h3>Consultation Timings</h3>

  <div className="footer-timing">

    <div className="timing-item">
      <h4>
        <a 
          href="https://maps.app.goo.gl/KkqDJtTL3dpEKeqaA" 
          target="_blank" 
          rel="noopener noreferrer"
          className="hospital-link"
        >
          Aadhya 9 Hospital, Shadipur
        </a>
      </h4>
      <p className="address">
        W-4, Metro Station Shadipur, Gate No. 4, adjoining Shadipur, West Patel Nagar, New Delhi, Delhi 110008
      </p>
      <p>Mon, Wed, Thu, Sat, Sun</p>
      <span>5:00 PM – 7:00 PM</span>
    </div>

    <div className="timing-item">
      <h4>
        <a 
          href="https://maps.app.goo.gl/CqRwvza2AJ6BdTKP8" 
          target="_blank" 
          rel="noopener noreferrer"
          className="hospital-link"
        >
          Apollo Cradle, Moti Nagar
        </a>
      </h4>
      <p className="address">
        M562+M57, Moti Nagar, Karampura Industrial Area, Karam Pura, New Delhi, Delhi 110015
      </p>
      <p>Tue, Fri</p>
      <span>5:00 PM – 7:00 PM</span>
    </div>

    <div className="timing-item">
      <h4>
        <a 
          href="https://maps.app.goo.gl/BjscmiU75xnYgFJg9" 
          target="_blank" 
          rel="noopener noreferrer"
          className="hospital-link"
        >
          Kailash IVF, Noida
        </a>
      </h4>
      <p className="address">
        A - 43 & 44, D-Block, Sector 26, Noida, Uttar Pradesh 201301
      </p>
      <p>9:00 AM – 1:00 PM</p>
      <span className="closed">(Thursday Closed)</span>
    </div>

  </div>
</div>

        {/* SOCIAL MEDIA */}
        <div className="footer-col">
          <h3>Follow Us</h3>
          <div className="footer-social">
            <a 
              href="https://www.instagram.com/dr.monikafertilitydoctor/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <i className="bi bi-instagram"></i> 
            </a>

            <a 
              href="https://twitter.com/DrMonica_Gupta" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <i className="bi bi-twitter"></i> 
            </a>

  <a 
              href="https://youtube.com/@drmonicaguptafertilitydoc?si=94ZhE3i5RaTDteOc" 
              target="_blank" 
              rel="noopener noreferrer"
            >
             

            <i class="bi bi-youtube"></i>
            </a>
          </div>
        </div>

      </div>

      <div className="footer-divider"></div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Dr. Monika Gupta. All Rights Reserved. Developed by <a href="https://strixdigital.in">Strix Digital</a>
      </div>
    </footer>
  )
}

export default Footer
